import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { stdObject } from "../../../data/types/stdObject";
import { colors } from "../../../data/colors";
import { sendData } from "../../../services/sendData";
import { processPersonsData } from "../../../utils/processPersonsData";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { userTypes } from "../../../data/types/userTypes";
import BasicButton from "../../BasicButton";
import { personsCodes } from "../../../data/main";
import { objectToArray } from "../../../utils/objectToArray";
import { removeAccents } from "../../../utils/removeAccents";
import { useMainContext } from "../../../context/MainContext";
import { checkPriceRange } from "../../../screens/MainFrame/functions/checkPriceRange";

let personQuickCounter: any = false;

export default function QuickPersonSearch({
  code,
  type,
  resList,
  setInputData,
  setResList,
  selectPos,
  setSelectPos,
  target,
  value = "",
  updateFunction,
  newFunction,
  casualFunction,
  cleanFunction,
}: stdObject) {
  const { t } = useTranslation();
  const { logoutAction, setMsg2, setModalData2, closeMsg } = useMainContext();
  const user: userTypes = useSelector((state: RootState) => state.data.user);
  const pricesRates: Array<stdObject> = useSelector(
    (state: RootState) => state.data.tar,
  );
  const condPricesRates: stdObject[] = useSelector(
    (state: RootState) => state.data.ta0,
  );
  const usersList: stdObject = useSelector(
    (state: RootState) => state.data.usersList,
  );
  const sellerList = objectToArray("CODUSU", usersList).filter(
    (e: stdObject) => e.COMROL === 0 && e.ACTIVO,
  );
  const [loading, setLoading] = useState(false);
  const rowRefs = useRef<Array<HTMLTableRowElement | null>>([]);
  const realType = type === "RES" ? "CLI" : type;

  const findPersons = async () => {
    let responseQuickPerson: stdObject = { success: false };

    if (type === "USU") {
      responseQuickPerson = {
        success: true,
        list: sellerList.filter((e: stdObject) =>
          removeAccents(e.NOMUSU).includes(removeAccents(value)),
        ),
      };
    } else {
      const payloadQuickPerson = {
        type: realType,
        code: value,
        searchList: { [`COD${realType}`]: { value, mode: 1 } },
        orSearch: { key: `NOM${realType}`, value, mode: 3 },
        sort: { value: `NOM${realType}`, mode: 0 },
        service: code === "INT",
        limit: 100,
      };
      // console.log("payloadQuickPerson", payloadQuickPerson);

      responseQuickPerson = await sendData({
        endPoint: "callPersonsList",
        payload: payloadQuickPerson,
        logoutAction,
      });
    }

    // console.log("responseQuickPerson", responseQuickPerson);

    if (responseQuickPerson.success) {
      if (personsCodes.includes(realType)) {
        responseQuickPerson.list = processPersonsData(
          realType,
          responseQuickPerson.list,
        );
      }
      setResList(responseQuickPerson.list);
      setSelectPos(0);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (personQuickCounter) {
      clearTimeout(personQuickCounter);
    }
    if (value !== "") {
      if (!loading) {
        setLoading(true);
      }
      personQuickCounter = setTimeout(findPersons, 500);
    }
  }, [value]);

  useEffect(() => {
    const currentRow = rowRefs.current[selectPos];

    if (currentRow) {
      currentRow.scrollIntoView({
        behavior: "smooth",
        block: "center", // "start" | "center" | "end" | "nearest"
      });
      currentRow.focus();
    }
  }, [selectPos]);

  return value !== "" ? (
    <div
      className="quickSearch"
      style={{
        top: 30,
        overflow: loading ? "hidden" : "auto",
      }}
    >
      {loading ? (
        <div className="spinner" style={{ width: 20, height: 20 }} />
      ) : (
        <div>
          {Array.isArray(resList) && !!resList.length ? (
            <table
              cellPadding={10}
              cellSpacing={0}
              style={{ cursor: "pointer" }}
            >
              <tbody>
                {resList.map((e: stdObject, index: number) => (
                  <tr
                    key={index}
                    ref={(el) => {
                      rowRefs.current[index] = el;
                    }}
                    style={{
                      backgroundColor:
                        index === selectPos
                          ? colors.lightBlue
                          : index % 2 === 0
                            ? colors.white
                            : colors.lightGrey,
                    }}
                    onClick={() => {
                      setResList([]);
                      setInputData({ open: false, code: "", search: "" });
                      checkPriceRange(type, target, e, {
                        t,
                        updateFunction,
                        condPricesRates,
                        pricesRates,
                        setMsg2,
                        setModalData2,
                        logoutAction,
                        closeMsg,
                      });
                    }}
                  >
                    <td style={{ whiteSpace: "nowrap" }}>
                      {e[`COD${realType}`]}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {e[`NOM${realType}`]}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>{t("p.noResults")}</div>
          )}
        </div>
      )}
    </div>
  ) : (Number(user[`${realType}N` as keyof typeof user]) > 0 &&
      target === "CLI" &&
      personsCodes.includes(realType)) ||
    target === "RES" ? (
    <div
      className="quickSearch noSelect"
      style={{
        top: 30,
        cursor: "pointer",
      }}
    >
      {personsCodes.includes(realType) && (
        <BasicButton
          onClick={newFunction}
          title={t("p.new")}
          color={colors.green}
          style={{ marginBottom: 5, width: "100%" }}
        />
      )}
      {user[`${realType}N` as keyof typeof user] === 2 && (
        <BasicButton
          onClick={casualFunction}
          title={
            target === "RES"
              ? t("p.occasionalPerson")
              : t("p.occasionalCustomer")
          }
          style={{ marginBottom: 5, width: "auto" }}
        />
      )}
      {cleanFunction && (
        <BasicButton
          onClick={cleanFunction}
          title={t("p.erase")}
          color={colors.red}
          style={{ width: "100%" }}
        />
      )}
    </div>
  ) : (
    <></>
  );
}
